import { useState } from "react";
import JoinAssessmentConfirmationModal from "../JoinAssesmentConfirmationModal";
import NotificationModal from "../NotificationModal";
import { useJoinVqaRequest } from "../../custom-hooks/queries";
import { resolveProviderDisplayName } from "../../utils/calendarRowDisplay";

const RESULT = {
  success: {
    title: "Request Submitted",
    desc: "Your join request has been submitted successfully.",
    error: false,
  },
  failure: {
    title: "Request Failed",
    desc: "There was an error submitting your join request. Please try again.",
    error: true,
  },
};

/**
 * Request to Join straight from the Assessment Calendar: a sponsor that is not on the
 * assessment gets the join form only, never the assessment's Details page.
 * `row` opens the form; `onClose` clears it; `onJoined` refreshes the calendar.
 */
export default function CalendarJoinRequestFlow({ row, onClose, onJoined }) {
  const [result, setResult] = useState(null);
  const { mutate: joinVqa } = useJoinVqaRequest();

  const handleConfirm = (additionalInfo, selectedServices, desiredInitialDraftDate, providerContacts) => {
    const vqaId = row.vqa_id;
    onClose();
    joinVqa(
      {
        id: vqaId,
        additional_info: additionalInfo,
        selected_services: selectedServices,
        desired_initial_draft_date: desiredInitialDraftDate,
        provider_contacts: providerContacts,
      },
      {
        onSuccess: () => {
          setResult(RESULT.success);
          onJoined?.();
        },
        onError: () => setResult(RESULT.failure),
      }
    );
  };

  return (
    <>
      <JoinAssessmentConfirmationModal
        open={Boolean(row)}
        setOpen={onClose}
        onConfirm={handleConfirm}
        servicesScopes={row?.capabilities || []}
        vendorName={resolveProviderDisplayName(row)}
        providerId={row?.provider_id}
      />
      <NotificationModal
        open={Boolean(result)}
        setOpen={() => setResult(null)}
        title={result?.title}
        desc={result?.desc}
        error={result?.error}
      />
    </>
  );
}
